export default __webpack_public_path__ + "static/media/31.fc13408b.jpg";